import React from 'react';
import { Typography } from '@/components/common';
import { MessageDate } from '@/components/chat/MessageDate';
import { DocumentLastMessage } from '@/interfaces/clientDocumentation';
import clsx from 'clsx';

interface Props {
	lastMessage: DocumentLastMessage | null | undefined;
	className?: string;
}

export const LastMessageBubble: React.FC<Props> = ({
	lastMessage,
	className,
}) => {
	if (!lastMessage?.content) return null;

	return (
		<div className={clsx('mt-2', className)}>
			<div className="bg-green-secondary p-3 rounded-tr-2xl rounded-b-2xl">
				<Typography type="regular-16" className="!text-left">
					{lastMessage.content}
				</Typography>
			</div>
			{lastMessage.created_at && (
				<MessageDate date={lastMessage.created_at} className="mt-1" />
			)}
		</div>
	);
};
